import React from 'react';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  name: 'María Laura G.',
  province: 'Buenos Aires',
  stars: 5,
  text: 'Empecé con muchas dudas, pero desde el primer tomo entendí cosas de mi cuerpo que ningún médico me había explicado. Hoy me siento más conectada conmigo misma que nunca.'
}, {
  name: 'Martín R.',
  province: 'Córdoba',
  stars: 5,
  text: 'Siempre pensé que esto era solo para mujeres, pero la BIODECODIFICACION me ayudó a entender dolores de espalda que arrastraba hace años. Fue revelador.'
}, {
  name: 'Valentina R.',
  province: 'Santa Fe',
  stars: 5,
  text: 'El material es increíblemente completo. Los 6 tomos están explicados de forma clara y práctica. Ya estoy aplicando lo aprendido con mis consultantes.'
}, {
  name: 'Diego F.',
  province: 'Mendoza',
  stars: 5,
  text: 'No podía creer la calidad del contenido por ese precio. Es una formación que en otros lugares te cobran 10 veces más. Súper recomendable para cualquier persona.'
}, {
  name: 'Agustina D.',
  province: 'Tucumán',
  stars: 5,
  text: 'Gracias a esta formación pude entender patrones familiares que se repetían hace generaciones. Hoy acompaño a otras personas en su proceso de sanación.'
}, {
  name: 'Santiago L.',
  province: 'Entre Ríos',
  stars: 5,
  text: 'El Vademécum interactivo es una herramienta espectacular. Lo consulto todos los días en mis sesiones. La versión Premium vale cada peso.'
}];
function StarRating({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5" data-id="element-191">
      {Array.from({
      length: count
    }).map((_, i) => <span key={i} className="text-[#eab308] text-sm" data-id="element-192">
          ★
        </span>)}
    </div>;
}
function TestimonialCard({
  name,
  province,
  stars,
  text,
  index
}: {
  name: string;
  province: string;
  stars: number;
  text: string;
  index: number;
}) {
  const [ref, vis] = useReveal();
  return <div ref={ref} className={`reveal bg-[#111111] border border-white/10 rounded-xl p-5 sm:p-6 flex flex-col gap-3 transition-all duration-500 hover:border-[#eab308]/30 hover:shadow-[0_0_20px_rgba(234,179,8,0.08)] ${vis ? 'is-visible' : ''}`} style={{
    transitionDelay: `${index * 100}ms`
  }} data-id="element-193">
      <StarRating count={stars} data-id="element-194" />
      <p className="text-gray-300 text-sm sm:text-base leading-relaxed flex-grow italic" data-id="element-195">
        "{text}"
      </p>
      <div className="flex items-center gap-3 pt-2 border-t border-white/5" data-id="element-196">
        <div className="w-9 h-9 rounded-full bg-[#eab308]/15 border border-[#eab308]/25 flex items-center justify-center flex-shrink-0" data-id="element-197">
          <span className="text-[#eab308] font-bold text-sm" data-id="element-198">
            {name.charAt(0)}
          </span>
        </div>
        <div data-id="element-199">
          <p className="text-white text-sm font-semibold" data-id="element-200">{name}</p>
          <p className="text-gray-500 text-xs" data-id="element-201">{province}, Argentina</p>
        </div>
      </div>
    </div>;
}
export function TestimonialsSection() {
  const [refTitle, visTitle] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-4 sm:px-6 border-t border-white/5" data-id="element-202">
      <div className="container mx-auto max-w-5xl" data-id="element-203">
        <div ref={refTitle} className={`reveal text-center mb-10 ${visTitle ? 'is-visible' : ''}`} data-id="element-204">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 leading-tight text-[#eab308]" data-id="element-205">
            Lo que dicen nuestros alumnos
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-206">
            Historias reales de personas que transformaron su vida con
            BIODECODIFICACION Integral.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-207">
          {TESTIMONIALS.map((t, i) => <TestimonialCard key={i} {...t} index={i} data-id="element-208" />)}
        </div>
      </div>
    </section>;
}